module.exports = __webpack_public_path__ + "media/src/components/Footer/LicenseSection/aba-91c90083eb60c95032c098dc1b4ac40b.png";